<template>
    <div>
        <!-- <button class="btn" @click="showValue()">TEST</button> -->
        <div class="text-center">
            <p class="red-text m-2"><i>{{$t('Account.modal.asterisk_required')}}</i></p>
        </div>

        <div class="main" :class="{'main_mobile' : isScreenSmall}">
            <div class="sub-container_mobile mx-4" :class="{'sub-container' : !isScreenSmall}">
              <div>
              </div>
              <div>
                <!-- <label v-show="isBrunoAccount" class="mt-3" for="name">{{$t('Account.modal.sageid')}} <strong v-if="isBrunoAccount" class="red-text">*</strong></label>
                <regular-datalist
                  v-show="isBrunoAccount"
                  :value="datalist.name"
                  @input="setSage($event)"
                  :sageOne="sageone"
                  class="datalist"/> -->
                <!-- LOCATION INFORMATION -->
                <custom-google-autocomplete
                    ref="AutocompleteUserInfo"
                    :label="$t('VGAutocomplete.search')"
                    :accountInfo="userInfo"
                    @updateEmptyGoogleFields="setEmptyGoogleFields">
                </custom-google-autocomplete>

                <label class="mt-3" for="name">{{$t('Account.modal.company_name')}} <strong class="red-text">*</strong></label>
                <regular-input
                    :class="{'missing-input_red-border' : isUserInfoFilled.name}"
                    id="name"
                    :placeholder="$t('Account.modal.company_name')"
                    :requiredField="false"
                    :value="userInfo.name"
                    @input="userInfo.name = $event"
                />      
            </div>

            <div>
                <label class="mt-3" for="address">{{$t('Account.modal.address')}} <strong class="red-text">*</strong></label>
                <regular-input
                    :class="{'missing-input_red-border' : isUserInfoFilled.address}"
                    id="address"
                    :placeholder="$t('Account.modal.address')"
                    :requiredField="false"
                    :value="userInfo.address"
                    :disabled="isGoogleInfoEmpty.address"
                    @input="userInfo.address = $event"
                />
            </div>

            <div>
                <label class="mt-3" for="city">{{$t('Account.modal.city')}} <strong class="red-text">*</strong></label>
                <regular-input
                    :class="{'missing-input_red-border' : isUserInfoFilled.city}"
                    id="city"
                    :placeholder="$t('Account.modal.city')"
                    :requiredField="false"
                    :value="userInfo.city"
                    :disabled="isGoogleInfoEmpty.city"
                    @input="userInfo.city = $event"
                />
            </div>

            <div>
                <label class="mt-3" for="postcode">{{$t('Account.modal.postcode')}} <strong class="red-text">*</strong></label>
                <regular-input
                    :class="{'missing-input_red-border' : isUserInfoFilled.postcode}"
                    id="postcode"
                    :placeholder="$t('Account.modal.postcode')"
                    :requiredField="false"
                    :value="userInfo.postcode"
                    :disabled="isGoogleInfoEmpty.postcode"
                    @input="userInfo.postcode = $event"
                />
            </div>

            <div>
                <label class="mt-3" for="province">{{$t('Account.modal.province')}} <strong class="red-text">*</strong></label>
                <regular-input
                    :class="{'missing-input_red-border' : isUserInfoFilled.province}"
                    id="province"
                    :placeholder="$t('Account.modal.province')"
                    :requiredField="false"
                    :value="userInfo.province"
                    :disabled="isGoogleInfoEmpty.province"
                    @input="userInfo.province = $event"
                />
            </div>
            
            <div>
                <label class="mt-3" for="country">{{$t('Account.modal.country')}} <strong class="red-text">*</strong></label>
                <regular-input
                    :class="{'missing-input_red-border' : isUserInfoFilled.country}"
                    id="country"
                    :placeholder="$t('Account.modal.country')"
                    :requiredField="false"
                    :value="userInfo.country"
                    :disabled="isGoogleInfoEmpty.country"
                    @input="userInfo.country = $event"
                />
            </div>
            </div>

            <!-- NON-LOCATION INFORMATION -->
            <div class="sub-container_mobile mx-4" :class="{'sub-container' : !isScreenSmall}">

            <div>
                <label class="mt-3" for="phone">{{$t('Account.modal.phone')}} <strong class="red-text">*</strong></label>
                <regular-input
                    :type="'tel'"
                    :class="{'missing-input_red-border' : isUserInfoFilled.phone}"
                    id="phone"
                    :placeholder="$t('Account.modal.phone')"
                    :requiredField="false"
                    :value="userInfo.phone"
                    @input="userInfo.phone = $event"
                />
            </div>

            <add-contact 
                :contactList.sync="userInfo.contacts" 
                :isAddContact.sync="isAddContact"
                :isEditContact.sync="isEditContact"
                :editIndex="editIndex"
                @update:contactList="updateContactList" />
            <div v-if="!isAddContact && !isEditContact" class="ml-1">
                <div v-for="(contact, index) in userInfo.contacts" :key="index" class="contact-display">
                    <p>{{ contact.name }}</p>
                    <div class="flex gap-2">
                    <button @click="editContact(index)"><i class="fa fa-pencil"></i></button>
                    <button @click="deleteContact(index)"><i class="fa fa-trash"></i></button>
                    </div>
                </div>
            </div>

            <label class="mt-3" for="payment-method"> {{ $t('Account.modal.payment_method') }} <strong class="red-text">*</strong></label>
              <regular-select
                class="mb-3"
                :value="userInfo.paymentMethod"
                @change="userInfo.paymentMethod= $event;"
                :placeholder="$t('Account.modal.select_payment_method')">
                <option v-for="pay in paymentMethods" :key="pay.label" :value="pay.label">{{ pay.label }}</option>
            </regular-select>

            <div v-if="userInfo.paymentMethod === 'Credit'" class="">
                <label class="mt-2" for="creditApplication"> {{ $t('Account.modal.credit_application_url') }}</label>
                <regular-input
                    :type="'text'"
                    id="creditApplication"
                    :placeholder="$t('Account.modal.enter_credit_url')"
                    :requiredField="false"
                    :value="userInfo.creditApplication"
                    @input="userInfo.creditApplication = $event"
                />

                <label class="mt-2" for="creditAmount"> {{ $t('Account.modal.credit_amount') }} <strong class="red-text">*</strong></label>
                <regular-input
                    :type="'number'"
                    id="creditAmount"
                    :placeholder="$t('Account.modal.enter_credit_amount')"
                    :requiredField="false"
                    :value="userInfo.creditAmount"
                    @input="userInfo.creditAmount = $event"
                />
            </div>

            <div>
                <label class="mt-3" for="fax">{{$t('Account.modal.fax')}}</label>
                <regular-input
                    id="fax"
                    :placeholder="$t('Account.modal.fax')"
                    :requiredField="false"
                    :value="userInfo.fax"
                    @input="userInfo.fax = $event"
                />
            </div>
            </div>

            <!-- ACCOUNT LOGIN INFORMATION -->
            <div class="sub-container_mobile mx-4" :class="{'sub-container' : !isScreenSmall}">
            <div>
                <label class="mt-3" for="email">{{$t('Account.modal.account_email')}}
                <strong class="red-text">*</strong>
                <div class="fa fa-info-circle shDisp__icon--hover" aria-hidden="true">
                    <p class="shDisp__icon--tooltip tooltip-dealer-right">{{$t('Account.modal.email_format_required')}}</p>
                </div>
                </label>
                <regular-input
                    :type="'email'"
                    :class="{'missing-input_red-border' : isUserInfoFilled.email}"
                    id="email"
                    :placeholder="$t('Account.modal.email')"
                    :requiredField="false"
                    :value="userInfo.email"
                    @input="userInfo.email = $event"
                />
            </div>

            <div>
                <label class="mt-3" for="password">{{$t('Account.modal.password')}}
                <strong class="red-text">*</strong>
                <div class="fa fa-info-circle shDisp__icon--hover" aria-hidden="true">
                    <p class="shDisp__icon--tooltip tooltip-right">{{$t('Account.modal.password_length_required')}}</p>
                </div>
                </label> 
                <regular-input
                    :class="{'missing-input_red-border' : isUserInfoFilled.password}"
                    id="password"
                    :placeholder="$t('Account.modal.password')"
                    :requiredField="false"
                    :value="userInfo.password"
                    @input="userInfo.password = $event"/>
            </div>

            <div :class="{'loading-container' : isLoading}" class="mt-3">
                <div v-show="isLoading" class="loader"></div>
                <div v-show="!isLoading"></div>
            </div>

            <label class="mt-2" for="confirmBtn"></label>
            <div id="confirmBtn" class="mt-2">
                <p class="red-text" v-show="errorMessage" v-html="errorMessage"></p>
                <button class="w-100 btn btn-kne-orange mb-5" @click="confirmNewAccount()">{{$t('Account.modal.button_confirm_new')}}</button>
                <!-- <button v-show="isEditMode" class="w-100 btn btn-kne-orange" @click="confirmEditAccount()">{{$t('Account.modal.button_confirm_edit')}}</button> -->
            </div>

            </div>
        </div>
    </div>
</template>

<script>
  import RegularInput from '../../basic-components/regularInput.vue'
  import Navbar from '../../interface-components/NavBar.vue'
  import CustomGoogleAutocomplete from '../Custom-packages/Custom-GoogleAutocomplete.vue'
  import CustomVueDropzone from '../Custom-packages/Custom-VueDropzone.vue'
  import addContact from '../../basic-components/addContact.vue'
  import regularSelect from '../../basic-components/regularSelect.vue'
  
  import { MultiSelect } from 'vue-search-select'
  import 'vue-search-select/dist/VueSearchSelect.css'
  import { db, auth2 } from '../../../../firebase.js'
  // import _ from 'lodash'
  
  export default {
    name: 'NewDealerModal',
  
    props: {
      isFromNewOrder: {
        required: false,
        default: false,
        type: Boolean
      }
    },
  
    components: {
      RegularInput,
      Navbar,
      CustomVueDropzone,
      CustomGoogleAutocomplete,
      MultiSelect,
      addContact,
      regularSelect
    },
  
    data () {
      return {
        userInfo: {
          name: '',
          address: '',
          city: '',
          postcode: '',
          province: '',
          country: '',
          phone: '',
          contacts: [],
          lat: 0,
          long: 0,
          paymentMethod: '',
          creditApplication: '',
          creditAmount: '',
          discountType: '',
          discountAmount: '',
          discountAmountType: '',
          zones: [],
          // docs: '',
          // nir: '',
          // tps: '',
          // tvq: '',
          // cigle: '',
          fax: '',
          email: '',
          password: '',
          // logo: 'https://keepneye.s3.amazonaws.com/KeepNeye.png',
          sageID: '',
          language: '',
          status: '',
          transporterUid: ''
        },
        transpLinkList: [],
        sageOneNameFilter: '',
        isUserInfoFilled: { // This serves as setting required fields and changing missing fields style
          name: false,
          address: false,
          city: false,
          postcode: false,
          province: false,
          country: false,
          phone: false,
          email: false,
          password: false
        },
        isGoogleInfoEmpty: {
          address: true,
          city: true,
          postcode: true,
          province: true,
          country: true
        },
        datalist: {
          name: '',
          key: ''
        },
        errorMessage: '',
        isLoading: false,
        transporterUidInfo: {},
        sageone: [],
        isAddContact: false,
        isEditContact: false,
        editIndex: 0,
        paymentMethods: [
          {value: 'COD', label: `${this.$t('Account.modal.cod_pay')}`},
          {value: 'Credit', label: `${this.$t('Account.modal.credit_pay')}`}
        ],
        allowedFileTypes: ['.pdf', '.jpg', '.png', '.doc', '.docx']
      }
    },

    created () {
        this.transporterUidInfo = this.$store.state.userInfo

        this.$bindAsArray('sageone', db.ref('sageoneid/' + this.companyUID), null, () => {
          this.filteredSearchMethodSage()
        })
    },
  
    methods: {
      /** Create new account */
      confirmNewAccount () {
        if (!this.initiateFormProcess()) return
        this.isLoading = true
        auth2.createUserWithEmailAndPassword(this.userInfo.email, this.userInfo.password)
          .then((userCredential) => {
            this.setDefaultData()
            this.userInfo.password = '' // Empty password to not save in DB
            this.updateUserInfoTransporterUid
            db.ref('users').child('pending-creation').child(userCredential.user.uid).set(this.userInfo).then(() => {
              let object = {
                to: this.transporterUidInfo.email,
                type: 'AccountCreation'
              }
              db.ref('email-request3').push().set(object)
            }).catch((error) => {
              this.errorMessage = this.$t('Account.transporter_email_not_found')
              console.log(error)
              console.log('Email/Courriel:', this.transporterUidInfo.email)
              this.isLoading = false
            })
  
            if (this.isFromNewOrder) {
              this.onApproveAccount(userCredential.user.uid)
            }
            this.resetFields()
            alert(this.$t('Account.modal.account_created_alert'))
            this.isLoading = false
            this.closeAddDealerModal()
          })
        .catch((error) => {
          console.log(error)
          this.setErrorMessage(error.code)
          this.isLoading = false
        })
      },

      onApproveAccount (uid) {
        this.isLoading = true
        const EAKey = uid

        const newAccountDetails = this.setEdittedFields()
        const transporterDealerLinkList = this.setTransporterDealerLinkList(true)

        this.createAccountInFirebase(EAKey)
        this.saveDealerAccountDetails(newAccountDetails, EAKey)
        this.saveTransporterDealerLinkList(transporterDealerLinkList, EAKey, true)
        this.updatePendingAccountFB(EAKey, 'Approved')
        this.sendEmail(this.userInfo.email)

        /** @emits TransporterAccounts.vue */
        this.$emit('closeEditModal', false)
      },

      setEdittedFields (status) {
        const uInfo = this.userInfo
        let liste = this.setTransporterLinkList()

        let updatedFields = {
          'name': uInfo.name,
          'address': uInfo.address,
          'city': uInfo.city,
          'postcode': uInfo.postcode,
          'province': uInfo.province,
          'contacts': uInfo.contacts || [],
          'paymentMethod': uInfo.paymentMethod || '',
          'creditAmount': uInfo.creditAmount || '',
          'creditApplication': uInfo.creditApplication || '',
          'country': uInfo.country,
          'phone': uInfo.phone,
          'fax': uInfo.fax,
          'sageID': uInfo.sageID || '',
          'liste': liste,
          'companyUID': this.companyUID
        }

        return updatedFields
      },
      setSage (event) {
        if (event.key) {
          this.datalist.name = event.value
          this.userInfo.sageID = event.key
        } else {
          this.datalist.name = event.value
        }
    },
      /** Set the @param listDeal in @firebase users/transporters/uid */
      setTransporterDealerLinkList (isLinked) {
        let tempObject = {}

        this.transpLinkList.forEach(transporter => {
          tempObject[transporter.uid] = {
            'linked': isLinked,
            'name': transporter.text
          }
        })

        return tempObject
      },

      /** Approved accounts have their @param companyUid
      * set to the logged in account that approved them
      */
      setTransporterLinkList () {
        if (!this.userInfo.liste) this.userInfo.liste = {}
        let transporterList = this.userInfo.liste

        this.transpLinkList.forEach(transporter => {
          let tempObject = {}
          let uid = ''

          uid = transporter.uid

          tempObject = {
            [uid]: transporter.text
          }

          transporterList = Object.assign(this.userInfo.liste, tempObject)
        })

        return transporterList
      },
      createAccountInFirebase (EAKey) {
        let info = this.userInfo

        db.ref('users').child('dealers').child(EAKey).set(info).then(() => {
          db.ref('users').child('dealersman').child(EAKey).set({
            'company': EAKey,
            'infos': {
              'language': 'en'
            },
            'role': 'Admin'
          })
        })
      },

      modifyingSage: function (customer) {
        this.sageOneChange.target = customer
        this.datalist.name = ''
        this.datalist.key = null
        this.sageCustomer = Object.values(customer.C || {})
        this.modifySage = true
      },

      filteredSearchMethodSage: window._.debounce(function () {
        this.filterResultsSageOne = []
        this.filterResultsSageOne = this.sageone.filter((entry) => {
          var reg = this.sageOneNameFilter.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
          var re = new RegExp(reg, 'i')
          var result = re.test(entry.A)
          return result
        })
      }, 100),

      /** Update at @param EAKey new info */
      saveDealerAccountDetails (newAccountDetails, EAKey) {
        db.ref('users').child('dealers').child(EAKey).update(newAccountDetails)
      },

      /** For each account in @param transporterDealerLinkList, add the currently editted account as a link */
      saveTransporterDealerLinkList (transporterDealerLinkList, EAKey, isLinked) {
        for (const key in transporterDealerLinkList) {
          if (Object.hasOwnProperty.call(transporterDealerLinkList, key)) {
            const obj = {}
            obj[EAKey] = {
              'linked': isLinked,
              'name': this.edittedAccount.name
            }
            db.ref('users').child('transporters').child(key).child('listDeal').update(obj)
          }
        }
      },

      /** Update an account in @PendingCreation @Firebase */
      updatePendingAccountFB (EAKey, newStatus) {
        db.ref('users').child('pending-creation').child(EAKey).update({
          'status': newStatus,
          'transporterUid': this.companyUID
        })
      },

      /** Send an email to the created account that they are pogging */
      sendEmail (emailTarget) {
        let emailObj = {
          to: emailTarget,
          subject: 'Account Created',
          text: 'Hi, <br><br> Your account is now ready to use.<br><br>Thank you,<br>Keep N Eye'
        }

        db.ref('email-request4').push().set(emailObj)
      },

      initiateFormProcess () {
        this.errorMessage = ''
        let isGoodToGo
  
        let areAllFieldsFilled = this.checkFilledInfo()
        if (areAllFieldsFilled) isGoodToGo = true
        else isGoodToGo = false
  
        return isGoodToGo
      },
  
      /** Pass through each key attribute in @param userInfo and check if its value empty
       *  If it's empty, update @param areAllFieldsFilled to false
       */
       checkFilledInfo () {
          let areAllFieldsFilled = true

          for (const key in this.isUserInfoFilled) {
            if (Object.hasOwnProperty.call(this.isUserInfoFilled, key)) {
              const element = this.userInfo[key]
              if (element === '') {
                this.isUserInfoFilled[key] = true // For input fields that are missing
                areAllFieldsFilled = false
                this.setErrorMessage('missing-fields')
              } else this.isUserInfoFilled[key] = false
            }
          }
          areAllFieldsFilled = this.checkPaymentInfo(areAllFieldsFilled)
          areAllFieldsFilled = this.checkContactTypes(areAllFieldsFilled)

          return areAllFieldsFilled
        },

        checkPaymentInfo (areAllFieldsFilled) {
          if (!this.userInfo.paymentMethod || (this.userInfo.paymentMethod === 'Credit' && !this.userInfo.creditAmount)) {
            this.setErrorMessage('missing-fields')
            return false
          }
          return areAllFieldsFilled
        },

        checkContactTypes (areAllFieldsFilled) {
          if (this.userInfo.contacts.length === 0) {
            this.setErrorMessage('missing-contacts')
            return false
          }

          const { isLogisticsContact, isBillingContact } = this.hasRequiredContactTypes()
          if (!isLogisticsContact) {
            this.setErrorMessage('logistic-contact-missing')
            return false
          }

          if (!isBillingContact) {
            this.setErrorMessage('billing-contact-missing')
            return false
          }

          return areAllFieldsFilled
        },

        hasRequiredContactTypes () {
          const contactList = this.userInfo.contacts
          let isLogisticsContact = false
          let isBillingContact = false

          contactList.forEach(contact => {
            if (contact.dealerType.includes('BILLING')) {
              isBillingContact = true
            }
            if (contact.dealerType.includes('LOGISTICS')) {
              isLogisticsContact = true
            }
          })

          return { isLogisticsContact, isBillingContact }
        },
  
      /** Some error types are given by Firebase's account auth system */
      setErrorMessage (errorType) {
        switch (errorType) {
          case 'auth/invalid-email':
            this.errorMessage = this.$t('Account.modal.email_error')
            this.isUserInfoFilled.email = true
            break
  
          case 'auth/email-already-in-use':
            this.errorMessage = this.$t('Account.modal.email_exists_error')
            this.isUserInfoFilled.email = true
            break
  
          case 'auth/weak-password':
            this.errorMessage = this.$t('Account.modal.password_error')
            this.isUserInfoFilled.password = true
            break
  
          case 'missing-fields':
            this.errorMessage = this.$t('Account.modal.missing_fields_error')
            break
  
          case 'missing-contacts':
            this.errorMessage = this.$t('Account.modal.missing_contacts_error')
            break
  
          case 'logistic-contact-missing':
            this.errorMessage = this.$t('Account.modal.missing_logistics_contact_error')
            break
  
          case 'billing-contact-missing':
            this.errorMessage = this.$t('Account.modal.missing_billing_contact_error')
            break
  
          default:
            this.errorMessage = this.$t('Account.modal.default_error')
            break
        }
      },
  
      /** When custom-google-autocomplete receives an emit from @emits Custom-GoogleAutocomplete.vue */
      setEmptyGoogleFields (info) {
        this.isGoogleInfoEmpty = info
      },
  
      /** When custom-vue-dropzone receives an emit from @emits Custom-Vuedropzone.vue */
      updateDropzoneLogo (dropzoneLogo) {
        this.userInfo.logo = dropzoneLogo
      },
  
      /** Resets user input fields to be empty */
      resetFields () {
        // Reset userInfo
        this.userInfo = {
          name: '',
          address: '',
          city: '',
          postcode: '',
          province: '',
          country: '',
          phone: '',
          contacts: [],
          lat: 0,
          long: 0,
          paymentMethod: '',
          creditApplication: '',
          creditAmount: '',
          discountType: '',
          discountAmount: '',
          discountAmountType: '',
          zones: [],
          fax: '',
          email: '',
          password: '',
          language: '',
          status: '',
          transporterUid: '',
          sageID: ''
        }

        // Reset VGA fields
        this.isGoogleInfoEmpty = {
          address: true,
          city: true,
          postcode: true,
          province: true,
          country: true
        }

        this.setDefaultData()
      },
      updateContactList (newContactList) {
        this.userInfo.contacts = newContactList
      },
  
      editContact (index) {
        this.editIndex = index
        this.isEditContact = true
      },
  
      deleteContact (index) {
        this.userInfo.contacts.splice(index, 1)
      },

      closeAddDealerModal () {
        this.$emit('closeAddDealerModal')
      },
      setDefaultData () {
        let object = this.userInfo
        // Set lang and status
        object.status = 'Pending'
        object.language = 'fr'
      },
  
      onResize: window._.debounce(function () {
        this.isScreenSmall = window.innerWidth < 600
      }, 100)
    },
    mounted () {
      this.onResize()
      window.addEventListener('resize', this.onResize, { passive: true })
    },
  
    beforeDestroy () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', this.onResize, { passive: true })
      }
    },
    watch: {
      sageone: function () {
        this.filteredSearchMethodSage()
      }
    },
    computed: {
      updateUserInfoTransporterUid () {
        this.userInfo.transporterUid = this.companyUID
      },

      companyUID () {
        return this.$store.state.authorization.company
      }
    }
  }
</script>
  
<style scoped>
.main {
    display: flex;
    justify-content: center;
    flex-flow: row;
}

.sub-container {
    min-width: 25%;
    max-width: 25%;
}

.main_mobile {
    display: flex;
    justify-content: center;
    flex-flow: column;
}

.sub-container_mobile {
    justify-content: space-between;
}

.button-container {
    display: flex;
    justify-content: space-between;
}

img {
    min-width: 200px;
    max-width: 50%;
    height: auto;
}

.red-text {
    color: rgb(220, 0, 0);
}
.green-text {
    color: green;
}
.missing-input_red-border {
    border-radius: 3px;
    border: 1px solid red !important;
}

.contact-display {
    display: flex;
    justify-content: space-between;
}

.document-date__item--mobile {
    width: 100%;
}

.document-date__item {
    min-width: 100%;
    max-width: 100%;
}

label {
    white-space: nowrap;
}

.link_removed-opacity {
    opacity: 0.5;
}
</style>
